module.exports = __webpack_public_path__ + "img/bigpackfast-active.5dd154d3.svg";